import React from "react";
import classnames from "classnames";
import Lottie from "lottie-react";

import loadingAnimation from "./loadingStarsAnimation.json";

import css from "./AiLoadingState.module.scss";

export default function AiLoadingState({ lottieClassName }: { lottieClassName?: string }) {
  return (
    <div className={css.loading}>
      <Lottie
        animationData={loadingAnimation}
        className={classnames(lottieClassName ?? css.lottie)}
      />
    </div>
  );
}
